module.exports = {
          srcSet: __webpack_public_path__ + "images/1902-c2f44d327f4901c1bb3ecb9a44cdc9e2-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1902-f7bd504b594d6b71f5716bc9871f8b6b-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1902-c2f44d327f4901c1bb3ecb9a44cdc9e2-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1902-f7bd504b594d6b71f5716bc9871f8b6b-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1902-c2f44d327f4901c1bb3ecb9a44cdc9e2-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1902-c2f44d327f4901c1bb3ecb9a44cdc9e2-320.jpg"},
          
          width: 320,
          height: 251
        }